import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTabChangeEvent, MatTabGroup, MatTab } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { PolicyUpgradePolicy } from 'src/app/models/interface/cam.interface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { PolicyManagementService } from 'src/app/services/dataLayer/CAM/policy-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { PolicyContentService } from '../../services/policy-content.service';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { NgIf } from '@angular/common';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-upgrade-policy',
    templateUrl: './upgrade-policy.component.html',
    styleUrls: ['./upgrade-policy.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, MatTabGroup, MatTab, MatFormField, MatLabel, MatInput, NgSelectComponent, AutoBlurSelectDirective, NgIf, MatError, MatRadioGroup, MatRadioButton, MatButton, MatProgressSpinner]
})  
export class UpgradePolicyComponent implements OnInit {
  commonApiLists: any = {
    cabinCategory: ["Business", "First"],
    Business: ["First"],
    First: []
  }
  commonObj = {
    id: 0,
    isSubmitting: false,
    tabIndex: 0
  }
  upgradePolicyCopyForm: FormGroup;
  upgradePolicyForm: PolicyUpgradePolicy = {
    upgradeClassFrom: "",
    exclusive: true,
    inclusive: false,
    callFor: "3",
    upgradeCategoryUpto: "",
    upgradeClassDuration: "",
    upgradeFareDiffUpto: "",
    upgradeBusinessAfterTripDur: "",
    additionalUpgradeCategoryUpto: "",
    additionalUpgradeClassDuration: "",
    upgradePremiumEconomy: ""
  };
  policyList: any;
  private destroy$ = new Subject<void>();
  content:any;
  saveMode!:string;
  constructor(private _FormBuilder: FormBuilder, private _CommonService: CommonService, private _ActivatedRoute: ActivatedRoute, private _CryptoService: CryptoService, private _ToastrApiService: ToastrApiService, private _CamService: CamService, private _Router: Router, private _PolicyManagementService: PolicyManagementService, private _CompanyManagementService: CompanyManagementService, private contentService:PolicyContentService) {
    this.upgradePolicyCopyForm = this._FormBuilder.group({
      classFrom: "Guest",
      Guest: this._FormBuilder.group({
        upgrade: this._FormBuilder.group({
          hh: ["", [Validators.min(0), Validators.max(23), Validators.pattern(/^([0-5]?[0-9])$/)]],
          mm: ["", [Validators.min(0), Validators.max(59), Validators.pattern(/^([0-5]?[0-9])$/)]],
          cabin: null
        }),
        additional: this._FormBuilder.group({
          hh: ["", [Validators.min(0), Validators.max(23), Validators.pattern(/^([0-5]?[0-9])$/)]],
          mm: ["", [Validators.min(0), Validators.max(59), Validators.pattern(/^([0-5]?[0-9])$/)]],
          cabin: null
        }),
        layover: "Inclusive"
      }),
      Business: this._FormBuilder.group({
        upgrade: this._FormBuilder.group({
          hh: ["", [Validators.min(0), Validators.max(23), Validators.pattern(/^([0-5]?[0-9])$/)]],
          mm: ["", [Validators.min(0), Validators.max(59), Validators.pattern(/^([0-5]?[0-9])$/)]],
          cabin: null
        }),
        layover: "Inclusive"
      }),
    })
  }
  ngOnInit() {
    this._CamService.policySaveMode$.pipe(takeUntil(this.destroy$)).subscribe(m=>{
      this.saveMode=m;
    });

    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    })
    if (!!this._ActivatedRoute.snapshot.queryParams['enc']) {
      this.commonObj.id = this._CryptoService.decryptData(this._ActivatedRoute.snapshot.queryParams['enc'])?.policyID;
      this._CamService.getPolicyManagementByID(this.commonObj.id).then(($: any) => {
        if ($.data?.[10]?.Branchlist?.length) {
          let form: PolicyUpgradePolicy = $.data?.[10].Branchlist[0];
          this.editFormSetup(form);
        }
      })
    }

    //GTM use
    this._PolicyManagementService.policyListValue.subscribe((result: any) => {
      this.policyList = result
    })

    this._PolicyManagementService.page_landing('Policy Management - Upgrade Policy', this.policyList.length, 'Policy Management Workflow')//GTM use
  }
  tabChange({ index }: MatTabChangeEvent) {
    if (index == 0) {
      this.upgradePolicyCopyForm.get("classFrom")?.setValue("Guest");
    } else if (index == 1) {
      this.upgradePolicyCopyForm.get("classFrom")?.setValue("Business");
    }
  }
  save() {
    this._PolicyManagementService.policy_upgrade_save('Policy Upgrade Policy','Save')//GTM use
    this.formSetup();
    this.commonObj.isSubmitting = true;
    this._CamService.postUpgradePolicy(this.commonObj.id, this.upgradePolicyForm).then(($: any) => {
      this._ToastrApiService.show('success', this.saveMode=='add' ? "Upgrade policy has been saved successfully!":'Upgrade policy has been updated successfully!');
      this._PolicyManagementService.save_success('Upgrade policy', 'Save')//GTM use
      this._PolicyManagementService.policy_edit_success('CTA');
      this.commonObj.isSubmitting = false;
      this._Router.navigate(["/cam/policy-management"]);
    }).catch((error: any) => {
      const message =
          error?.error?.message ||
          error?.message;
      this._PolicyManagementService.view_error_message(message,error?.code)
    })
  }
  formSetup() {
    let copy = JSON.parse(JSON.stringify(this._CommonService.removeNull(this.upgradePolicyCopyForm.value)));
    // if (copy.classFrom == "Guest") {
    if (!!copy[copy.classFrom].layover) {
      this.upgradePolicyForm.inclusive = copy[copy.classFrom].layover == "Inclusive";
      this.upgradePolicyForm.exclusive = copy[copy.classFrom].layover == "Exclusive";
    }
    if (!!copy.classFrom) {
      this.upgradePolicyForm.upgradeClassFrom = copy.classFrom;
    }
    this.upgradePolicyForm.upgradeClassDuration = `${copy[copy.classFrom].upgrade.hh ?? ""}.${copy[copy.classFrom].upgrade.mm ?? ""}`;
    this.upgradePolicyForm.upgradeCategoryUpto = copy[copy.classFrom].upgrade.cabin;
    this.upgradePolicyForm.additionalUpgradeClassDuration = `${copy[copy?.classFrom]?.additional?.hh ?? ""}.${copy?.[copy?.classFrom]?.additional?.mm ?? ""}`;
    this.upgradePolicyForm.additionalUpgradeCategoryUpto = copy?.[copy?.classFrom]?.additional?.cabin ?? "";
    if (this.upgradePolicyForm.upgradeClassDuration.length == 1 && this.upgradePolicyForm.upgradeClassDuration.includes(".")) {
      this.upgradePolicyForm.upgradeClassDuration = "";
    }
    if (this.upgradePolicyForm.additionalUpgradeClassDuration.length == 1 && this.upgradePolicyForm.additionalUpgradeClassDuration.includes(".")) {
      this.upgradePolicyForm.additionalUpgradeClassDuration = "";
    }
  }
  editFormSetup(form: any) {
    this.commonObj.tabIndex = form.Upgrade_Class_From == "Business" ? 1 : 0;
    if (form.Upgrade_Class_From == "Guest") {
      this.upgradePolicyCopyForm?.get(form?.Upgrade_Class_From)?.patchValue({ layover: form.Inclusive === '1' ? "Inclusive" : "Exclusive" });
      this.upgradePolicyCopyForm?.get(form?.Upgrade_Class_From)?.patchValue({ classFrom: form.Upgrade_Class_From ?? "" });
      const [hh, mm] = form.Upgrade_Class_Duration?.split('.') ?? ['', ''];
      this.upgradePolicyCopyForm?.get(form?.Upgrade_Class_From)?.get('upgrade')?.patchValue({
        hh: this.filterResult(hh),
        mm: this.filterResult(mm),
        cabin: form.Upgrade_Category_Upto || null
      });
      if (form.Upgrade_Category_Upto) {
      }
      const [addHh, addMm] = form.AdditionalUpgrade_Class_Duration?.split('.') ?? ['', ''];
      this.upgradePolicyCopyForm?.get(form?.Upgrade_Class_From)?.get('additional')?.patchValue({
        hh: this.filterResult(addHh),
        mm: this.filterResult(addMm),
        cabin: form.AdditionalUpgrade_Category_Upto || null
      });
      // if (form.AdditionalUpgrade_Category_Upto) {
      // }
    } else if (form.Upgrade_Class_From == "Business") {
      this.upgradePolicyCopyForm?.get(form?.Upgrade_Class_From)?.patchValue({ layover: form.Inclusive === '1' ? "Inclusive" : "Exclusive" });
      this.upgradePolicyCopyForm?.get(form?.Upgrade_Class_From)?.patchValue({ classFrom: form.Upgrade_Class_From ?? "" });
      const [hh, mm] = form.Upgrade_Class_Duration?.split('.') ?? ['', ''];
      this.upgradePolicyCopyForm?.get(form?.Upgrade_Class_From)?.get('upgrade')?.patchValue({
        hh: this.filterResult(hh),
        mm: this.filterResult(mm),
        cabin: form.Upgrade_Category_Upto || null
      });
      if (form.Upgrade_Category_Upto) {
      }
    }
  }
  dropdownChange(controlName: string) {
    this.upgradePolicyCopyForm.get(controlName)?.setValue(null)
  }
  navigateToList() {
    this._PolicyManagementService.policy_upgrade_Cancel('Policy Upgrade Policy','Cancel')//GTM use
    this._CamService.resetPolicyFormsMode();
    this._Router.navigate(["cam", "policy-management"]);
  }
  filterResult(value: string) {
    return ["", "undefined", "null"].includes(value) ? "" : value;
  }
}
